<template>
  <div>
    <b-card
      class="m-3"
      id="protocolo-processo-mesa-trabalho-header-Card"
      header-tag="header"
    >
      <template #header>
        <h6 class="mb-0 text-center">
          <b-button
            v-if="canVisualizarPecaUnica && modal === false"
            class="float-right m-1"
            size="sm"
            variant="outline-secondary"
            :disabled="baixandoPecaUnica"
            @click="verPecaUnica"
          >
            <b-spinner
              v-if="baixandoPecaUnica"
              small
              class="mx-1 mx-sm-0 mr-sm-2"
            />
            <font-awesome-icon
              v-else
              icon="file-pdf"
              class="mx-1 mx-sm-0 mr-sm-2"
            />
            <span class="d-none d-sm-inline">
              {{ baixandoPecaUnica ? "Baixando..." : "Peça Única" }}
            </span>
          </b-button>
          <span class="titulo-sagres font-weight-bold">
            Dados do
            {{
              detalhe.Tipo && detalhe.Tipo.toLowerCase() === "processo"
                ? "Processo"
                : "Protocolo"
            }}
          </span>
          <btn-voltar v-if="modal === false" />
        </h6>
      </template>
      <b-card-text>
        <DetalheProtocolo
          v-if="detalhe.Tipo && detalhe.Tipo.toLowerCase() === 'protocolo'"
          :protocolo="detalhe"
        >
        </DetalheProtocolo>
        <DetalheProcesso
          v-if="detalhe.Tipo && detalhe.Tipo.toLowerCase() === 'processo'"
          :processo="detalhe"
        >
        </DetalheProcesso>
      </b-card-text>
    </b-card>
    <b-card
      class="m-3"
      id="protocolo-processo-mesa-trabalho-interessados-header-Card"
      header-tag="header"
      v-if="detalhe.InteressadosList && detalhe.InteressadosList.length"
      no-body
      stacked="sm"
    >
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="font-weight-bold">Interessados</span>
        </h6>
      </template>
      <b-card-text>
        <b-table
          :fields="fieldsInteressados"
          hover
          no-border-collapse
          :items="detalhe.InteressadosList"
          show-empty
          striped
          stacked="sm"
        >
          <template #empty="">Não há informações disponíveis.</template>
        </b-table>
      </b-card-text>
    </b-card>
    <b-card
      class="m-3"
      id="protocolo-processo-mesa-trabalho-movimentacoes-header-Card"
      header-tag="header"
      v-if="detalhe.Movimentacoes && detalhe.Movimentacoes.length"
      no-body
    >
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="font-weight-bold">Movimentações</span>
        </h6>
      </template>
      <b-card-text>
        <b-table
          :fields="fieldsMovimentacoes"
          hover
          no-border-collapse
          :items="detalhe.Movimentacoes"
          :per-page="tableMovimentacoes.perPage"
          :current-page="tableMovimentacoes.currentPage"
          show-empty
          striped
          stacked="sm"
        >
          <template #empty="">Não há informações disponíveis.</template>
          <template v-slot:cell(DataInclusao)="row">
            {{ formatData(row.item.DataInclusao) }}
          </template>
        </b-table>
        <table-pagination
          :total-rows="tableMovimentacoes.totalRows"
          :per-page="tableMovimentacoes.perPage"
          tableID="tableMovimentacoes"
          @pageChange="pageChange"
        ></table-pagination>
      </b-card-text>
    </b-card>
    <b-card
      class="m-3"
      id="protocolo-processo-mesa-trabalho-multimidia-header-Card"
      header-tag="header"
      no-body
      v-if="detalhe.Arquivos && detalhe.Arquivos.length"
    >
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="font-weight-bold">Multimídia</span>
        </h6>
      </template>
      <b-card-text>
        <b-table
          :fields="fieldsMultimidia"
          hover
          no-border-collapse
          :items="detalhe.Arquivos"
          show-empty
          striped
          stacked="sm"
        >
          <template #empty="">Não há informações disponíveis.</template>
          <template v-slot:cell(DataInclusao)="row">
            {{ formatData(row.item.DataInclusao) }}
          </template>
          <template v-slot:cell(NomeArquivo)="row">
            <a href="#" @click.prevent="baixarMultimidia(row.item)">{{
              row.item.NomeArquivo
            }}</a>
          </template>
        </b-table>
      </b-card-text>
    </b-card>
    <b-card
      class="m-3"
      id="protocolo-processo-mesa-trabalho-relacionamentos-header-Card"
      header-tag="header"
      no-body
      v-if="detalhe.Relacionamentos && detalhe.Relacionamentos.length"
    >
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="font-weight-bold">Relacionamentos</span>
        </h6>
      </template>
      <b-card-text>
        <b-table
          :fields="fieldsRelacionamentos"
          hover
          no-border-collapse
          :items="detalhe.Relacionamentos"
          show-empty
          striped
          stacked="sm"
        >
          <template #empty="">Não há informações disponíveis.</template>
        </b-table>
      </b-card-text>
    </b-card>
    <b-card
      class="m-3"
      id="protocolo-processo-mesa-trabalho-ocorrencias-header-Card"
      header-tag="header"
      no-body
      v-if="
        detalhe.OcorrenciasJulgamento && detalhe.OcorrenciasJulgamento.length
      "
    >
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="font-weight-bold">Ocorrências Julgamento</span>
        </h6>
      </template>
      <b-card-text>
        <b-table
          :fields="fieldsOcorrencias"
          hover
          no-border-collapse
          :items="detalhe.OcorrenciasJulgamento"
          show-empty
          striped
          stacked="sm"
        >
          <template #empty="">Não há informações disponíveis.</template>
          <template v-slot:cell(DataSessao)="row">
            {{ formatData(row.item.DataSessao) }}
          </template>
        </b-table>
      </b-card-text>
    </b-card>
    <modal-pdf
      v-if="exibirModalPdfPecaUnica && pdfDataPecaUnica"
      @fecharModal="exibirModalPdfPecaUnica = false"
      :pdfData="pdfDataPecaUnica"
      :filename="getNomeArquivoPecaUnica().replace('.pdf', '')"
      :titulo="`Ver ${detalhe.Tipo && detalhe.Tipo.toLowerCase() === 'processo' ? 'Processo' : 'Protocolo'}`"
    />
  </div>
</template>
<script>
import DetalheProtocolo from "@/views/processo-eletronico/protocolos-processos/detalhe-protocolo.vue";
import DetalheProcesso from "@/views/processo-eletronico/protocolos-processos/detalhe-processo.vue";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import ModalPdf from "@/components/ModalPdf.vue";
import {
  baixarArquivoMultimidia,
  montarNomeArquivoPecaUnica,
  montarNomeArquivoMultimidia,
  processarPecaUnica,
  podeVisualizarPecaUnica,
} from "@/utils/peca-unica";
import { UtilsTS } from "@/utilsts";

export default {
  name: "ProtocoloProcessoComponente",
  components: {
    DetalheProtocolo,
    DetalheProcesso,
    TablePagination,
    BtnVoltar,
    ModalPdf
  },
  mixins: [UtilsTS],
  props: {
    detalhe: {
      type: Object,
      required: true,
    },
    modal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldsInteressados: [
        {
          key: "Nome",
          label: "Nome",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "Cpf",
          label: "CPF",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "TipoInteressado",
          label: "Tipo",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
      ],
      fieldsMovimentacoes: [
        {
          key: "DataInclusao",
          label: "Data",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "SetorOrigem",
          label: "Área Origem",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "SetorDestino",
          label: "Área Destino",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
      ],
      fieldsOcorrencias: [
        {
          key: "DataSessao",
          label: "Data da sessão",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "Descricao_Julgamento",
          label: "Descrição do julgamento",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "DescricaoOcorrencia",
          label: "Descrição da ocorrência",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
      ],
      fieldsMultimidia: [
        {
          key: "DataInclusao",
          label: "Data de Inclusão",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "NomeArquivo",
          label: "Nome",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "Descricao",
          label: "Descrição",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
      ],
      fieldsRelacionamentos: [
        {
          key: "TipoOrigem",
          label: "Tipo Origem",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "NumeroOrigem",
          label: "Nº Origem",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "TipoDestino",
          label: "Tipo Destino",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "NumeroDestino",
          label: "Nº Destino",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "TipoRelacionamento",
          label: "Relacionamento",
          tdClass: "align-middle",
          thClass: "text-center",
          sortable: true,
        },
      ],
      tableMovimentacoes: {
        perPage: 10,
        currentPage: 1,
        totalRows: 0
      },
      exibirModalPdfPecaUnica: false,
      pdfDataPecaUnica: null,
      baixandoPecaUnica: false,
    };
  },
  computed: {
    canVisualizarPecaUnica() {
      return podeVisualizarPecaUnica({
        codProtocoloCriptografado: this.detalhe?.CodProtocoloCriptografado,
        tipo: this.detalhe?.Tipo,
        codigoTipoDocumento: this.detalhe?.CodigoTipoDocumento
      });
    }
  },
  methods: {
    pageChange(value, tableID) {
      if (tableID == "tableMovimentacoes")
        this.tableMovimentacoes.currentPage = value;
    },
    async baixarMultimidia(arquivo) {
      try {
        const blob = await baixarArquivoMultimidia(String(arquivo.CodCriptografado));
        const nomeArquivo = montarNomeArquivoMultimidia(
          arquivo?.NomeArquivo,
          arquivo?.CodCriptografado
        );
        this.download(nomeArquivo, blob);
      } catch (error) {
        this.tratarError(error);
      }
    },
    getNomeArquivoPecaUnica() {
      return `${montarNomeArquivoPecaUnica(
        this.detalhe?.Tipo,
        this.detalhe?.Numero || this.detalhe?.Protocolo
      )}.pdf`;
    },
    async verPecaUnica() {
      this.baixandoPecaUnica = true;
      try {
        const resultado = await processarPecaUnica(
          this.detalhe.CodProtocoloCriptografado
        );
        if (resultado.acao === "download") {
          this.download(this.getNomeArquivoPecaUnica(), resultado.arquivo);
          return;
        }
        this.pdfDataPecaUnica = resultado.pdfData;
        this.exibirModalPdfPecaUnica = true;
      } catch (error) {
        this.tratarError(error);
      } finally {
        this.baixandoPecaUnica = false;
      }
    }
  },
};
</script>
<style></style>
